import { render, staticRenderFns } from "./ChatCategoryCounts.vue?vue&type=template&id=8e670e30&scoped=true&"
import script from "./ChatCategoryCounts.vue?vue&type=script&lang=js&"
export * from "./ChatCategoryCounts.vue?vue&type=script&lang=js&"
import style0 from "./ChatCategoryCounts.vue?vue&type=style&index=0&id=8e670e30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e670e30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VDivider,VProgressCircular,VRow})
